import { render, staticRenderFns } from "./liveTabs.vue?vue&type=template&id=2129d811&scoped=true"
import script from "./liveTabs.vue?vue&type=script&lang=js"
export * from "./liveTabs.vue?vue&type=script&lang=js"
import style0 from "./liveTabs.vue?vue&type=style&index=0&id=2129d811&prod&lang=less&scoped=true"
import style1 from "./liveTabs.vue?vue&type=style&index=1&id=2129d811&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2129d811",
  null
  
)

export default component.exports